<template>
  <el-form-item prop="capture">
    <template #label>
      <span
        >{{ i18nt('designer.setting.uploadPictureCapture') }}
        <el-tooltip effect="light" v-if="optionModel.capture === 'album'" placement="top" :content="i18nt('designer.setting.uploadPictureCaptureAlbumTip')"
          ><svg-icon icon-class="el-info"
        /></el-tooltip>
      </span>
    </template>

    <el-select default-first-option v-model="optionModel.capture" style="width: 100%">
      <el-option v-for="(ft, ftIdx) in uploadPictureCapture" :key="ftIdx" :label="ft.label" :value="ft.value"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
import SvgIcon from '@/components/svg-icon';

export default {
  components: { SvgIcon },
  name: 'm-picture-upload-capture-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const data = reactive({
      uploadPictureCapture: [
        { label: i18nt('designer.setting.uploadPictureCaptureAll'), value: '' },
        { label: i18nt('designer.setting.uploadPictureCaptureCamera'), value: 'camera' },
        { label: i18nt('designer.setting.uploadPictureCaptureAlbum'), value: 'album' },
      ],
    });

    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
    };
  },
};
</script>

<style scoped></style>
